import {
  PriceSettingsPaymentMethod,
  type ICartItemInfo,
} from '@setplex/tria-api'
import { sample } from 'effector'

import { model as priceSettingsModel } from '~/entities/price-settings'

import { aye } from '~/shared/helpers'
import {
  postItemToCartFx,
  postTvBundleEventToCart,
  postTvEventToCart,
} from './model'

// tv channel case
sample({
  clock: postTvEventToCart,
  source: {
    selectedPriceSettings: priceSettingsModel.$selectedPriceSettings,
  },
  filter: ({ selectedPriceSettings }, clockData) =>
    aye(clockData) &&
    aye(selectedPriceSettings) &&
    selectedPriceSettings?.paymentMethod === PriceSettingsPaymentMethod.PerItem,
  fn: ({ selectedPriceSettings }, clockData) => {
    const cartItemInfo: ICartItemInfo = {
      originalPrice: selectedPriceSettings!.price,
      channel: {
        channelId: clockData.channelId,
        pricingId: selectedPriceSettings!.priceSettingsId,
      },
    }

    return cartItemInfo
  },
  target: postItemToCartFx,
})

// // tv channelSet case
sample({
  clock: postTvBundleEventToCart,
  source: {
    selectedPriceSettings: priceSettingsModel.$selectedPriceSettings,
  },
  filter: ({ selectedPriceSettings }, clockData) =>
    aye(clockData) &&
    aye(selectedPriceSettings) &&
    selectedPriceSettings?.paymentMethod === PriceSettingsPaymentMethod.PerSet,
  fn: ({ selectedPriceSettings }, clockData) => {
    const cartItemInfo: ICartItemInfo = {
      originalPrice: selectedPriceSettings!.price,
      channelSet: {
        channelSetId: clockData.channelSetId,
        channelIds: clockData.channelIds,
        pricingId: selectedPriceSettings!.priceSettingsId,
      },
    }

    return cartItemInfo
  },
  target: postItemToCartFx,
})
